import { createReducer, on } from '@ngrx/store';
import { setPendingTasks, deletePendingTasks, setDossierPendingTasks, updatePendingTask, deletePendingTask } from './pending-tasks.actions';
import { TaskDTO } from '@/app/api/plyca-dtos';

export interface PendingTasksState {
  pendingTasks: TaskDTO[];
}

export const initialPendingTasksState: PendingTasksState = {
  pendingTasks: []
};

export const reducer = createReducer<PendingTasksState>(
  initialPendingTasksState,
  on(setPendingTasks, (state, { payload }) => ({
    ...state,
    pendingTasks: payload.tasks
  })),
  on(deletePendingTasks, (state) => ({
    ...state,
    pendingTasks: initialPendingTasksState.pendingTasks
  })),
  on(setDossierPendingTasks, (state, { payload }) => {
    let result = state.pendingTasks.filter((item) => item.division.project.identifier !== payload.dossierId);
    if (payload.tasks != null) {
      result = result.concat(payload.tasks);
    }
    return {
      ...state,
      pendingTasks: result
    };
  }),
  on(updatePendingTask, (state, { payload }) => {
    const updatedPendingTasks = state.pendingTasks.map((item) => {
      // Actualizamos los datos de estado de bloqueo de la tarea
      // No queremos sustituirla por la consultada porque puede tener datos diferentes
      // a los que se dispone en el gestor de tareas
      if (item.identifier === payload.task.identifier) {
        const arrayKeysExcept = ['status', 'lockedBy', 'availableActions'];
        const temp = structuredClone(payload.task);
        Object.keys(temp).forEach(function (key) {
          if (arrayKeysExcept.indexOf(key) === -1) {
            delete temp[key];
          }
        });

        return Object.assign({}, item, temp);
      } else {
        return item;
      }
    });

    return {
      ...state,
      pendingTasks: updatedPendingTasks
    };
  }),
  on(deletePendingTask, (state, { payload }) => ({
    ...state,
    pendingTasks: state.pendingTasks.filter((item) => item.identifier !== payload.identifier)
  }))
);
